import { State } from 'store/store';
import getStore from 'services/getStore';
import { assessmentScoringAverageOrFirstPassed } from './SCORM';

let SCORMToHostingValues: { [key: string]: any } | undefined;
let delay;

let delayLogs;

enum ScoringCriteria {
  ADDITIVE = 'ADDITIVE',
  AVERAGE = 'AVERAGE',
  PASSED_ASSESSMENTS = 'PASSED_ASSESSMENTS',
}

const SCORMToHosting = ($: object, key: null | string = null) => {
  const isHosted = (window as any).getParams().hosted;

  clearTimeout(delayLogs);

  delayLogs = setTimeout(() => {
    //
  }, 1000);

  if (Object.values($).filter(value => value)?.length === 0) {
    console.log('no values. should we bail ???');
    //
  }

  if (!isHosted) {
    return isHosted;
  }

  const state = (getStore().getState() || {}) as State;

  if (!SCORMToHostingValues) {
    const {
      scoreData,
      interactionsSeen,
      interactionsLocked,
      landingPagesSeenState,
      assessments,
      moduleVariables,
    } = {
      scoreData: state.userBehaviour.score,
      ...state,
    };

    SCORMToHostingValues = {
      data: {
        scoreData,
        interactionsSeen,
        interactionsLocked,
        landingPagesSeenState,
        assessments,
        moduleVariables,
      },
    };
  }

  if (key) {
    SCORMToHostingValues = {
      ...SCORMToHostingValues,
      [key]: {
        ...SCORMToHostingValues[key],
        ...$,
      },
    };
  } else {
    SCORMToHostingValues = {
      ...SCORMToHostingValues,
      ...$,
    };
  }

  if (
    [ScoringCriteria.AVERAGE, ScoringCriteria.PASSED_ASSESSMENTS].includes(
      SCORMToHostingValues.scoringCriteria
    )
  ) {
    const {
      version,
      scoringCriteria,
      lessonStatus,
      lastInteractionSeen,
      allInteractionsSeen,
      moduleCompleteInterationRequirement,
      moduleCompleteScoreRequirement,
    } = $ as any;

    const _assessmentScoringAverageOrFirstPassed_ = assessmentScoringAverageOrFirstPassed(
      {
        scorm: null,
        version,
        scoringCriteria,
        lessonStatus,
        lastInteractionSeen,
        allInteractionsSeen,
        moduleCompleteInterationRequirement,
        moduleCompleteScoreRequirement,
      }
    );

    const {
      scoreMax,
      scoreRaw,
      passed,
    } = _assessmentScoringAverageOrFirstPassed_;

    SCORMToHostingValues = {
      ...SCORMToHostingValues,
      scoreMax,
      scoreRaw,
      scorePercent: (scoreRaw / scoreMax) * 100 || 0,
      passed,
    };
  }

  clearTimeout(delay);

  delay = setTimeout(() => {
    const raw = JSON.stringify({
      hosting: { learning_module_session_data: SCORMToHostingValues },
    });

    const myHeaders = new Headers();
    myHeaders.append('Accept', 'application/json');
    myHeaders.append('Content-Type', 'application/json');

    const requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const projectId = (window as any).getParams().projectId;

    const endPoint = `${window.chameleon.CHAMELEON_URL}/harp/hosting/${projectId}/data`;

    fetch(endPoint, requestOptions)
      .then(response => {
        // console.log({ response });

        return response.text();
      })
      .then(result => {
        console.log(result);
      })
      .catch(error => {
        console.log('error', error);
        console.log(raw);
      });
  }, 300);
  // 1000 / 60
};

export default SCORMToHosting;
